const locale = {
    placeholder: 'Seleccionar hora',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/ca_ES.tsx